import { useTranslation } from 'react-i18next';
import { InlineAlert, Widget } from '@asset-metrix/portal-ui';

import styles from './pageContentError.module.scss';

export type PageContentErrorProps = {
  message?: string;
};

export function PageContentError({ message }: PageContentErrorProps) {
  const { t } = useTranslation();
  return (
    <Widget
      title={t('app.page.pageContentErrorTitle')}
      dataTestId="content-error"
    >
      <InlineAlert className={styles['root_content_error']}>
        <div>
          {`${t('app.page.contentNotFoundError')} ${t('app.noAccessError.resolution')}`}
          <p>{message}</p>
        </div>
      </InlineAlert>
    </Widget>
  );
}
